module.exports = "/layout/app/images/bg-section-why-choose-us-before.a5dd9ebb.svg";